module.exports = __webpack_public_path__ + "img/icon-img.18a604bc.svg";